// extracted by mini-css-extract-plugin
export default {"imageLayer":"imageLayer__MTg3M","rounded":"rounded__YTZhZ","border":"border__MzcwZ"};